<svg
   fill="none"
   viewBox="0 0 48 48"
   version="1.1"
   xml:space="preserve"
   width="48"
   height="48"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#a)" transform="matrix(1.0666393,0,0,1.0666551,-3.4462069,-3.1999653)">
        <path fill="#002991" d="m 38.914,13.35 c 0,5.574 -5.144,12.15 -12.927,12.15 H 18.49 L 18.122,27.822 16.373,39 H 7.056 L 12.661,3 h 15.095 c 5.083,0 9.082,2.833 10.555,6.77 a 9.687,9.687 0 0 1 0.603,3.58 z" />
        <path fill="#60cdff" d="M 44.284,23.7 A 12.894,12.894 0 0 1 31.53,34.5 H 26.324 L 24.157,48 H 14.89 l 1.483,-9 1.75,-11.178 0.367,-2.322 h 7.497 c 7.773,0 12.927,-6.576 12.927,-12.15 3.825,1.974 6.055,5.963 5.37,10.35 z" />
        <path fill="#008cff" d="M 38.914,13.35 C 37.31,12.511 35.365,12 33.248,12 H 20.608 L 18.49,25.5 h 7.497 c 7.773,0 12.927,-6.576 12.927,-12.15 z" />
    </g>
</svg>
